module.exports = __webpack_public_path__ + "img/dragon.dc373c79.jpg";